import { render, staticRenderFns } from "./AboutModal.vue?vue&type=template&id=b8f86f28&scoped=true"
import script from "./AboutModal.vue?vue&type=script&lang=js"
export * from "./AboutModal.vue?vue&type=script&lang=js"
import style0 from "./AboutModal.vue?vue&type=style&index=0&id=b8f86f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f86f28",
  null
  
)

export default component.exports